import React, { useState, useMemo } from 'react';
import { ComingSoonWeek } from '@/api/coming-soon';

import CloseCircleIcon from '@/assets/close-circle-outline.svg';
import CaretDownIcon from '@/assets/caretDownLight.svg';

interface ComingSoonSelectedReportsProps {
  tabs: Array<{
    tabName: string;
    reports: ComingSoonWeek['reports'];
  }>;
  onUnsubscribe: (reportId: string) => void;
}

const ComingSoonSelectedReports: React.FC<ComingSoonSelectedReportsProps> = ({ tabs, onUnsubscribe }) => {
  const [showReports, setShowReports] = useState(false);

  const numberOfSelectedReports = useMemo(
    () => tabs.reduce((count, week) => count + week.reports.filter((report) => report.isSubscribed).length, 0),
    [tabs],
  );

  const toggleReports = () => setShowReports(!showReports);

  return (
    <div className="sticky bottom-0 z-[8] mt-5 -mb-4 min-h-[50px] w-full max-w-full self-start bg-[#cdcdcd] px-5 py-2.5 text-black">
      <button
        onClick={toggleReports}
        className="-mt-8 flex h-[50px] w-[50px] cursor-pointer items-center justify-center rounded-full border-none bg-[#cdcdcd] outline-none focus:outline-none active:scale-95"
        style={{ WebkitTapHighlightColor: 'transparent' }}
      >
        <CaretDownIcon
          className={`w-5 transition-transform duration-500 ease-in-out ${showReports ? '' : 'rotate-180'}`}
        />
      </button>

      <span
        className="text-xs font-semibold sm:text-sm md:text-base"
        style={{ fontFamily: 'Sohne-Semi-Bold, sans-serif' }}
      >
        View Selected Reports ({numberOfSelectedReports})
      </span>

      <div
        className={`overflow-hidden transition-all duration-500 ease-in ${showReports ? 'max-h-[100px]' : 'max-h-0'}`}
      >
        <div className="mx-0 my-[5px] flex gap-2 overflow-x-auto pb-1 sm:mx-[5px] sm:gap-12">
          {tabs.map((tab) => (
            <div
              key={tab.tabName}
              className="ml-1 min-w-[200px] flex-shrink-0 border-r border-black pr-2 text-[14px] last:border-r-0"
            >
              <div className="mb-1 font-semibold" style={{ fontFamily: 'Sohne-Semi-Bold, sans-serif' }}>
                {tab.tabName}
              </div>
              {tab.reports
                .filter((report) => report.isSubscribed)
                .map((report) => (
                  <div key={report.reportId} className="mb-1 flex items-start gap-1">
                    <div className="inline-block p-[3px]">
                      <CloseCircleIcon
                        className="mr-[5px] h-5 w-5 cursor-pointer align-middle"
                        onClick={() => onUnsubscribe(report.reportId)}
                      />
                    </div>
                    <div className="ml-[6px] inline-block p-[3px]">
                      <span className="text-[12px]">{report.title}</span>
                    </div>
                  </div>
                ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ComingSoonSelectedReports;
